import { Navigate, RouteObject } from "react-router";
import { CompanyListRoute } from "@/routes/base-data/companies/list/company-list-route";
import { CompanyRoute } from "@/routes/base-data/companies/[companyId]/company-route";
import { CompanyProfileRoute } from "@/routes/base-data/companies/[companyId]/profile/company-profile-route";
import { CompanyDataRoute } from "@/routes/base-data/companies/[companyId]/data/company-data-route";
import { CompanyMasterDataPdfRoute } from "@/routes/base-data/companies/[companyId]/pdf/company-master-data-pdf-route";
import { CompanyMasterDataPdfListRoute } from "@/routes/base-data/companies/[companyId]/pdf/company-master-data-pdf-list-route";
import { CompanyMasterDataPdfEditRoute } from "@/routes/base-data/companies/[companyId]/pdf/[masterDataPdfId]/company-master-data-pdf-edit-route";

export const companiesRoutes: RouteObject[] = [
  {
    index: true,
    element: <CompanyListRoute />,
  },
  {
    path: ":companyId",
    element: <CompanyRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="data" replace />,
      },
      {
        path: "data",
        element: <CompanyDataRoute />,
      },
      {
        path: "profile",
        element: <CompanyProfileRoute />,
      },
      {
        path: "pdf",
        element: <CompanyMasterDataPdfRoute />,
        children: [
          {
            index: true,
            element: <CompanyMasterDataPdfListRoute />,
          },
          {
            path: ":masterDataPdfId",
            element: <CompanyMasterDataPdfEditRoute />,
          },
        ],
      },
    ],
  },
];
